export const ADD_DATASET = 'app/Datasets/ADD_DATASET'
export const ADD_DATASET_DONE = 'app/Datasets/ADD_DATASET_DONE'
export const ADD_DATASET_ERROR = 'app/Datasets/ADD_DATASET_ERROR'
export const GET_ADD_DATASET_STATUS = 'app/Datasets/GET_ADD_DATASET_STATUS'
export const UPDATE_ADD_DATASET_STATUS =
  'app/Datasets/UPDATE_ADD_DATASET_STATUS'
export const CLEAR_DATASET_ERROR = 'app/Datasets/CLEAR_DATASET_ERROR'

export const LIST_DATASETS = 'app/Datasets/LIST_DATASETS'
export const CLEAR_DATASETS = 'app/Datasets/CLEAR_DATASETS'
export const LIST_DATASETS_DONE = 'app/Datasets/LIST_DATASETS_DONE'
export const LIST_DATASETS_ERROR = 'app/Datasets/LIST_DATASETS_ERROR'

export const UPDATE_DATASET = 'app/Datasets/UPDATE_DATASET'
export const UPDATE_DATASET_DONE = 'app/Datasets/UPDATE_DATASET_DONE'
export const UPDATE_DATASET_ERROR = 'app/Datasets/UPDATE_DATASET_ERROR'

export const validationErrors = {
  REQUIRED: 'required'
}

export const DATASET_URL_EN =
  'https://intercom-help.eu/docu-tools-helpcenter/de/articles/278004-datasets-importieren'

export const DATASET_URL_DE =
  'https://intercom-help.eu/docu-tools-helpcenter/en/articles/278004-importing-datasets'
